"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOrUpdate = createOrUpdate;
exports.fromKey = fromKey;
exports.getCacheKeyForTileKey = getCacheKeyForTileKey;
exports.getKey = getKey;
exports.getKeyZXY = getKeyZXY;
exports.hash = hash;
exports.withinExtentAndZ = withinExtentAndZ;

/**
 * @module ol/tilecoord
 */

/**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */

/**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [opt_tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */
function createOrUpdate(z, x, y, opt_tileCoord) {
  if (opt_tileCoord !== undefined) {
    opt_tileCoord[0] = z;
    opt_tileCoord[1] = x;
    opt_tileCoord[2] = y;
    return opt_tileCoord;
  } else {
    return [z, x, y];
  }
}
/**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {string} Key.
 */


function getKeyZXY(z, x, y) {
  return z + '/' + x + '/' + y;
}
/**
 * Get the key for a tile coord.
 * @param {TileCoord} tileCoord The tile coord.
 * @return {string} Key.
 */


function getKey(tileCoord) {
  return getKeyZXY(tileCoord[0], tileCoord[1], tileCoord[2]);
}
/**
 * Get the tile cache key for a tile key obtained through `tile.getKey()`.
 * @param {string} tileKey The tile key.
 * @return {string} The cache key.
 */


function getCacheKeyForTileKey(tileKey) {
  var _a = tileKey.substring(tileKey.lastIndexOf('/') + 1, tileKey.length).split(',').map(Number),
      z = _a[0],
      x = _a[1],
      y = _a[2];

  return getKeyZXY(z, x, y);
}
/**
 * Get a tile coord given a key.
 * @param {string} key The tile coord key.
 * @return {TileCoord} The tile coord.
 */


function fromKey(key) {
  return key.split('/').map(Number);
}
/**
 * @param {TileCoord} tileCoord Tile coord.
 * @return {number} Hash.
 */


function hash(tileCoord) {
  return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
/**
 * @param {TileCoord} tileCoord Tile coordinate.
 * @param {!import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {boolean} Tile coordinate is within extent and zoom level range.
 */


function withinExtentAndZ(tileCoord, tileGrid) {
  var z = tileCoord[0];
  var x = tileCoord[1];
  var y = tileCoord[2];

  if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) {
    return false;
  }

  var tileRange = tileGrid.getFullTileRange(z);

  if (!tileRange) {
    return true;
  } else {
    return tileRange.containsXY(x, y);
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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